import dayjs from "dayjs";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

export const CheckoutPercentageDiscount = async (
  product,
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  discountValue,
  matchingApproval,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId,
  removeDiscounts
) => {
  const isExchange = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
  const tillData = useAuthStore.getState().tillData;
  const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const saleTypeValidation = pricingRule?.cwrSaletypeId === null || orderType === undefined ? true : pricingRule?.cwrSaletypeId === orderType?.cwrSaletype?.cwrSaletypeId;
  let modificationsMade = false; // Flag to indicate modifications

  // Iterate through each item in the cart
  cartObj.items.map((item) => {
    let excludingFlag = true;
    const matchingCategory = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);
    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategory) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategory && pricingRule.mPricingPcategories.length > 0) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingCustomerSegment = pricingRule.mPricingB2CCustomerSegments.find(
      (pc) => pc.cwrB2CCustomerSegmentId === cartObj.customer?.b2cCustomerSegment?.cwrB2CCustomerSegmentId
    );

    if (
      (pricingRule.excludeB2CSegment === "Y" && matchingCustomerSegment) ||
      (pricingRule.excludeB2CSegment !== "Y" && !matchingCustomerSegment && pricingRule.mPricingB2CCustomerSegments.length > 0) ||
      (pricingRule.excludeB2CSegment === "N" && pricingRule.mPricingB2CCustomerSegments.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingCustomer = pricingRule.mPricingB2CCustomers.find((pc) => pc.b2cCustomerId === cartObj.customer.cwrCustomerId);
    if (
      (pricingRule.excludeB2CCustomers === "Y" && matchingCustomer) ||
      (pricingRule.excludeB2CCustomers !== "Y" && !matchingCustomer && pricingRule.mPricingB2CCustomers.length > 0) ||
      (pricingRule.excludeB2CCustomers === "N" && pricingRule.mPricingB2CCustomers.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBusinessUnit = pricingRule.mPricingBUnits.find((pc) => pc.mBunitPricingId === tillData.tillAccess.csBunit.csBunitId);
    if (
      (pricingRule.excludeBusinessUnits === "Y" && matchingBusinessUnit) ||
      (pricingRule.excludeBusinessUnits !== "Y" && !matchingBusinessUnit && pricingRule.mPricingBUnits.length > 0) ||
      (pricingRule.excludeBusinessUnits === "N" && pricingRule.mPricingBUnits.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);
    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand && pricingRule.mPricingBrands.length > 0) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);
    if (
      (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
      (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1 && pricingRule.mPricingXProducts.length > 0) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    let pricingRuleFlag = true;

    // Apply additional logic for pricingRuleFlag based on your requirements

    if (item.discount <= 0 && item.mPricingRulesId !== null && item.mPricingRulesId !== undefined) {
      pricingRule.mPricingXProducts.forEach((res) => {
        if (res.mProductId === item.productId) {
          delete item.priority;
        }
      });
    }

    if (
      saleTypeValidation &&
      excludingFlag &&
      pricingRuleFlag &&
      (product.productId === item.productId || iscoupon || removeDiscounts) &&
      (item?.priority ? item?.priority < pricingRule.priority : true) &&
      parseFloat(discountValue) <= 100
    ) {
      const offerIndex =
        pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "N"
          ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId)
          : pricingRule.mPricingXProducts.length > 0 && pricingRule.excludeProducts === "Y"
            ? pricingRule.mPricingXProducts.findIndex((op) => op.mProductId !== item.productId)
            : 0;

      if (offerIndex >= 0 && Math.abs(item.weight) >= pricingRule.minimumQty && item.lineId === product.lineId) {
        const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

        let allDiscounts = item?.allDiscounts || [];
        let approvalData = item?.approval || [];
        let matchedRuleIndex = allDiscounts.findIndex((d) => d.mPricingruleId === pricingRule.mPricingrulesId);
        if (matchedRuleIndex === -1) {
          allDiscounts.push({
            mPricingruleId: pricingRule.mPricingrulesId,
            discountValue: discountValue,
            discountType: pricingRule.type,
          });
        }

        let matchedApprovalIndex = approvalData.findIndex((d) => d.mPricingrulesId === pricingRule.mPricingrulesId);
        if (matchedApprovalIndex === -1) {
          approvalData.push({
            ...matchingApproval,
            time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            mPricingrulesId: pricingRule.mPricingrulesId,
          });
        }

        if (Array.isArray(item.children) && item.children.length > 0) {
          let parentNettotal = 0;
          let parentTaxAmount = 0;
          let parentDiscount = 0;
          item.children.forEach((child) => {
            const childDiscountAmt = parseFloat(((discountValue / 100) * parseFloat(child.realPrice)).toFixed(prcPrecision));
            const childSp = parseFloat(child.realPrice) - childDiscountAmt;
            const childMrp = parseFloat(childSp) * child.weight;
            const childTax = taxIncludeFlag === "Y" ? childMrp - childMrp / (1 + child.taxRate / 100) : (childMrp * child.taxRate) / 100;
            child.salePrice = childSp;
            child.taxAmount = parseFloat(childTax.toFixed(prcPrecision));
            child.nettotal = taxIncludeFlag === "Y" ? parseFloat(childMrp.toFixed(prcPrecision)) : parseFloat((childMrp + childTax).toFixed(prcPrecision));
            child.discount = parseFloat((childDiscountAmt * child.weight).toFixed(prcPrecision));
            child.discountName = pricingRule.printedName;
            child.mPricingruleId = pricingRule.mPricingrulesId;
            parentNettotal += child.nettotal;
            parentTaxAmount += child.taxAmount;
            parentDiscount += child.discount;
          });
          item.nettotal = parseFloat(parentNettotal.toFixed(prcPrecision));
          item.taxAmount = parseFloat(parentTaxAmount.toFixed(prcPrecision));
          item.discount = parseFloat(parentDiscount.toFixed(prcPrecision));
        } else {
          const discountAmt = ((discountValue / 100) * parseFloat(item.realPrice)).toFixed(prcPrecision);
          const sp = parseFloat(item.realPrice) - discountAmt;
          const mrp = parseFloat(sp) * item.weight;
          const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
          item.salePrice = sp;
          item.taxAmount = parseFloat(tax.toFixed(prcPrecision));
          item.nettotal = taxIncludeFlag === "Y" ? parseFloat(mrp.toFixed(prcPrecision)) : parseFloat((mrp + tax).toFixed(prcPrecision));
          item.discount = parseFloat((discountAmt * item.weight).toFixed(prcPrecision));
        }

        item.discountName = pricingRule.printedName;
        item.mPricingruleId = pricingRule.mPricingrulesId;
        item.nextRule = pricingRule.nextRule;
        item.iscoupon = iscoupon;
        item.couponInput = couponInput;
        item.referenceId = uniqReferenceId;
        item.mPricingCouponId = mPricingCouponId;
        item.priority = pricingRule.priority;
        item.allDiscounts = allDiscounts;
        item.approval = approvalData;

        modificationsMade = true;
      } else if (Array.isArray(item.children) && item.children.length > 0) {
        const prcPrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
        let parentNettotal = 0;
        let parentTaxAmount = 0;
        item.children.forEach((child) => {
          const childMrp = parseFloat(child.realPrice) * child.weight;
          const childTax = taxIncludeFlag === "Y" ? childMrp - childMrp / (1 + child.taxRate / 100) : (childMrp * child.taxRate) / 100;
          child.taxAmount = parseFloat(childTax.toFixed(prcPrecision));
          child.nettotal = taxIncludeFlag === "Y" ? parseFloat(childMrp.toFixed(prcPrecision)) : parseFloat((childMrp + childTax).toFixed(prcPrecision));
          child.discount = 0;
          child.discountName = "";
          child.mPricingruleId = null;
          parentNettotal += child.nettotal;
          parentTaxAmount += child.taxAmount;
        });
        item.taxAmount = parseFloat(parentTaxAmount.toFixed(prcPrecision));
        item.nettotal = parseFloat(parentNettotal.toFixed(prcPrecision));
        item.discount = 0;
        item.discountName = "";
        item.mPricingruleId = null;
        item.allDiscounts = [];
        delete item.nextRule;
      } else {
        const mrp = parseFloat(item.realPrice) * item.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
        item.taxAmount = parseFloat(tax.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.nettotal =
          taxIncludeFlag === "Y"
            ? parseFloat(mrp.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision))
            : parseFloat((mrp + tax).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
        item.discount = 0;
        item.discountName = "";
        item.mPricingruleId = null;
        item.allDiscounts = [];
        delete item.nextRule;
      }
    }
  });

  if (modificationsMade) {
    // Update the cart object with the adjusted items
    let couponsData = cart.couponInput?.length > 0 ? [...cart.couponInput] : [];
    if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null && mPricingRulesId) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: mPricingRulesId });
    }

    let uniqueArray = cart?.manualDiscountData?.lineLevelDiscount || [];
    let lineLevelDiscounts = cart?.manualDiscountData?.lineLevelDiscount || [];
    let totalLevelDiscounts = cart?.manualDiscountData?.totalLevelDiscount || [];

    // Get the highest sequenceNo across both arrays
    let allSequenceNos = [...lineLevelDiscounts.map((item) => item.sequenceNo), ...totalLevelDiscounts.map((item) => item.sequenceNo)];

    // Find the next available sequenceNo
    let nextSequenceNo = 1;
    while (allSequenceNos.includes(nextSequenceNo)) {
      nextSequenceNo++;
    }

    let duplicateIndex = uniqueArray.findIndex((item) => item.lineId === product.lineId);
    const itemData = {
      lineId: product.lineId,
      productId: product.productId,
      discountName: pricingRule.printedName,
      discountValue: discountValue,
      pricingRule: pricingRule.mPricingrulesId,
      sequenceNo: duplicateIndex === -1 ? nextSequenceNo : lineLevelDiscounts[duplicateIndex].sequenceNo,
    };
    if (duplicateIndex === -1) {
      uniqueArray.push(itemData);
    } else {
      uniqueArray[duplicateIndex] = itemData;
    }

    let manualDiscountData = {
      lineLevelDiscount: uniqueArray,
      ...cart.manualDiscountData,
    };

    const adjustedCartObj = {
      ...cartObj,
      items: cartObj.items,
      iscoupon: iscoupon,
      couponInput: couponsData,
      manualDiscountData: manualDiscountData,
    };
    if (isExchange) {
      useCartStore.getState().setExchangeCart(adjustedCartObj);
    } else {
      setCart(adjustedCartObj);
    }
    return adjustedCartObj;
  } else {
    return cartObj;
  }
};
